import { useCallback, useEffect, useState } from 'react';
import { FiActivity, FiEye, FiEyeOff } from 'react-icons/fi';
import { adminApi, type TrackedFeature } from '../../services/admin';
import styles from './Admin.module.css';
import { AdminLayout } from './AdminLayout';

export function AdminTracking() {
    const [features, setFeatures] = useState<TrackedFeature[]>([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        try { setFeatures(await adminApi.listTrackedFeatures()); }
        catch (e) { console.error(e); }
        finally { setLoading(false); }
    }, []);

    useEffect(() => { load(); }, [load]);

    const handleToggle = async (f: TrackedFeature) => {
        await adminApi.updateTrackedFeature(f.id, { isActive: !f.isActive });
        load();
    };

    return (
        <AdminLayout>
            <div className={styles.pageHeader}>
                <div className={styles.headerLeft}>
                    <h2>Tracking de Features</h2>
                    <p>Ative ou desative o monitoramento de cada funcionalidade para uso nos triggers</p>
                </div>
            </div>

            {loading ? (
                <div className={styles.loadingState}>Carregando...</div>
            ) : (
                <div className={styles.usersSection}>
                    {features.length === 0 ? (
                        <div className={styles.emptyState}>
                            <FiActivity size={48} style={{ opacity: 0.3 }} />
                            <p>Nenhuma feature disponível.</p>
                        </div>
                    ) : (
                        <table className={styles.usersTable}>
                            <thead>
                                <tr>
                                    <th>Chave</th>
                                    <th>Nome</th>
                                    <th>Descrição</th>
                                    <th>Status</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {features.map(f => (
                                    <tr key={f.id} className={!f.isActive ? styles.inactiveRow : ''}>
                                        <td><code style={{ fontSize: '0.8rem', background: 'var(--color-gray-100)', padding: '0.15rem 0.4rem', borderRadius: 4 }}>{f.key}</code></td>
                                        <td>{f.label}</td>
                                        <td><span className={styles.email}>{f.description ?? '-'}</span></td>
                                        <td>
                                            <span className={`${styles.statusBadge} ${f.isActive ? styles.active : styles.inactive}`}>
                                                {f.isActive ? 'Ativo' : 'Inativo'}
                                            </span>
                                        </td>
                                        <td>
                                            <div className={styles.actionButtons}>
                                                <button
                                                    className={styles.actionBtn}
                                                    title={f.isActive ? 'Desativar monitoramento' : 'Ativar monitoramento'}
                                                    onClick={() => handleToggle(f)}
                                                >
                                                    {f.isActive ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            )}
        </AdminLayout>
    );
}
